<!--
 * @Author: zly
 * @Date: 2021-08-06 09:16:49
 * @LastEditTime: 2021-12-22 15:44:56
 * @LastEditors: zly
 * @Description:
-->
<template>
  <div style="padding:10px;font-size:14px">
    <!-- 单点登录页 -->
    {{message}}
  </div>
</template>

<script>
import { clearLoginInfo } from '@/utils'
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
export default {
  name: 'punchoutLogin',
  data () {
    return {
      loginForm: {
        username: null,
        password: null,
        grant_type: 'password',
        appCode: window.SITE_CONFIG.appCode,
        client_id: 'shopping',
        loginType: '0'
      },
      message: ''
    }
  },
  computed: {},
  created () {
    clearLoginInfo()
    this.init()
    // http://plantmate.com/api/punchout-login?USERNAME=xxx&PASSWORD=xxx&CALLBACK_URL=xxx
    // http://localhost:8081/punchout-login?USERNAME=13216205771&PASSWORD=MTIzNHF3ZXI=&CALLBACK_URL=https://baidu.com
    // http://localhost:8081/punchout-login?USERNAME=13003090721&PASSWORD=cXdlcjAwMDA=&CALLBACK_URL=https://baidu.com
    // http://localhost:8081/punchout-login?USERNAME=&PASSWORD=123413&CALLBACK_URL=https://baidu.com
    // http://localhost:8081/punchout-login?USERNAME=13003090721&PASSWORD=&CALLBACK_URL=https://baidu.com
    // http://localhost:8081/punchout-login?USERNAME=13003090721&PASSWORD=123413&CALLBACK_URL=
  },
  mounted () {
  },
  methods: {
    init () {
      let routeQuery = this.$route.query
      let username = routeQuery.USERNAME
      let password = routeQuery.PASSWORD
      let CALLBACK_URL = routeQuery.CALLBACK_URL
      this.loginForm.username = username
      this.loginForm.password = password
      Cookies.set('CALLBACK_URL', CALLBACK_URL)
      // return false
      if (username && password && CALLBACK_URL) {
        this.dataFormSubmitHandle()
      } else if (!username) {
        this.message = '用户名不能为空'
      } else if (!password) {
        this.message = '密码不能为空'
      } else if (!CALLBACK_URL) {
        this.message = '回调地址不能为空'
      }
    },
    // 登录
    dataFormSubmitHandle: debounce(
      function () {
        // const Base64 = require('js-base64').Base64
        let params = Object.assign({}, this.loginForm)
        // params.password = Base64.encode(this.loginForm.password)
        this.$http
          .post('/auth/login', params)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              this.message = res.message
              return false
            }
            Cookies.set('access_token_shop', res.data.access_token)
            Cookies.set('username_shop', res.data.username)
            this.$router.push({
              name: 'punchoutIndex',
              query: {}
            })
          })
          .catch(() => {})
      },
      1000,
      { leading: true, trailing: false }
    )
  }
}
</script>

<style scoped lang="scss"></style>
